import { FC, useCallback } from 'react';

import { IReviewRow, IReviewsSection, Sections } from 'types';
import ReviewRow from 'pages/shopPage/content/reviews/reviewRow/ReviewRow';
import Section from 'components/section/Section';

const ReviewsSection: FC<IReviewsSection> = ({ list, onReviewsClick }) => {
  const itemContent = useCallback((item: IReviewRow, index: number) => {
    return (
      <ReviewRow
        id={item.id}
        key={`${item.id}-${index}`}
        name={item.name}
        value={item.value}
        avatar={item.avatar}
        title={item.title}
        text={item.text}
        date={item.date}
        images={item.images}
      />
    );
  }, []);

  return (
    <Section
      list={list}
      itemContent={itemContent}
      type={Sections.Reviews}
      onButtonClick={onReviewsClick}
    />
  );
};

export default ReviewsSection;
